import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("userToken"));
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        throw new Error("Please enter a valid email address.");
      }

      if (!password || password.length < 5) {
        throw new Error("Password must be at least 5 characters long.");
      }

      const response = await fetch("https://inaaniserver-50c4305cc7f7.herokuapp.com/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && Array.isArray(data) && data.length > 0) {
        const user = data[0];
        localStorage.setItem("userToken", user.token);
        localStorage.setItem("userData", JSON.stringify(user));
        localStorage.setItem("userRole", user.role);

        setUser(user);
        setIsLoggedIn(true);
        setError(null);
        return { success: true, user };
      } else {
        const errorMessage = data.message || "Incorrect email or password.";
        throw new Error(errorMessage);
      }
    } catch (err) {
      const errorMessage = err.message || "An unexpected error occurred during login.";
      setError(errorMessage);
      return { success: false, message: errorMessage };
    }
  };

  const logout = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");

    setUser(null);
    setIsLoggedIn(false);
    setError(null);

    window.dispatchEvent(new Event("userLoggedOut"));
    window.location.href = "/";
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, isLoggedIn, login, logout, error, userId: user?.id }}>
      {children}
    </AuthContext.Provider>
  );
};